export default __webpack_public_path__ + "static/media/kitfo.fec6a0d3.jpg";